// extracted by mini-css-extract-plugin
module.exports = {"organizationName":"NameCell_organizationName__2WBWG"};